var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../utils/dateUtils", "./reportBase"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DateUtils, ReportBase) {
    "use strict";
    var AgentGroupsSummaryReport = /** @class */ (function (_super) {
        __extends(AgentGroupsSummaryReport, _super);
        function AgentGroupsSummaryReport() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.reinitFilterTimer = 0;
            _this.domainGroups = ko.observableArray();
            _this.selectedDomainGroups = ko.observableArray();
            _this.reportData = ko.observableArray();
            _this.defaultDomain = "izzy.telego.com";
            _this.resizeTimeout = 0;
            _this.allDetailGrids = {};
            _this.queuesSummaryChart = {};
            return _this;
        }
        AgentGroupsSummaryReport.prototype.init = function () {
            var self = this;
            $(window).off("resize.ace_hover");
            tools.ajaxGet({
                url: "/Reports/GetGroupsSummaryLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                        self.domainList = data.Data.lookupLists.CdrDomains;
                        self.defaultDomain = data.Data.lookupLists.DefaultDomain;
                    }
                    self.initMain();
                    ko.applyBindings(self, document.getElementById("ko-main-content"));
                    self.initRest();
                    $(".loader-container").hide();
                    $("#mainContext").show();
                    if (!self.filterCdrByDomain()) {
                        self.filterCdrByDomain(self.defaultDomain);
                    }
                    self.initSummaryGrid(self.lookupLists.GridStructures.ReportAgentGroupSummaryStructure);
                }
            });
        };
        AgentGroupsSummaryReport.prototype.initRest = function () {
            var self = this;
        };
        AgentGroupsSummaryReport.prototype.onDomainChanged = function () {
            var self = this;
            self.selectedDomainGroups([]);
            self.getDomainAccounts(self.filterCdrByDomain());
            _super.prototype.onDomainChanged.call(this);
        };
        AgentGroupsSummaryReport.prototype.getDomainAccounts = function (domain) {
            var self = this;
            tools.ajaxPost({
                url: "/Reports/GetDomainAccountsData",
                data: { domain: domain },
                success: function (data) {
                    if (data.Data) {
                        self.domainGroups(data.Data.filter(function (item) {
                            return item.Type === "acds";
                        }));
                    }
                }
            });
        };
        AgentGroupsSummaryReport.prototype.openFilterDialog = function () {
            $("#advancedFilterDialog").modal("show");
        };
        AgentGroupsSummaryReport.prototype.filterClicked = function () {
            var self = this;
            var groups = $("input:checkbox[name=filterByGroup]:checked").map(function (index, element) { return $(element).val(); }).get();
            self.selectedDomainGroups(groups);
            $("#advancedFilterDialog input[name='showColumn']").each(function (index, element) {
                var isChecked = $(element).is(":checked");
                var value = $(element).val();
                if (isChecked) {
                    self.mainTable.getGridData().showColumn(value);
                }
                else {
                    self.mainTable.getGridData().hideColumn(value);
                }
            });
            $("#advancedFilterDialog").modal("hide");
            self.applyFilter();
        };
        AgentGroupsSummaryReport.prototype.initSummaryGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            var nameColumn = ko.utils.arrayFirst(gridStructure.columns, function (column) {
                return column.field === "Id";
            });
            nameColumn.template = function (dataItem) {
                var html = ""; //"<span class='label label-info'><i class='fa fa-user'></i></span>";
                html += '<a title="View Details" class="label label-info"  target="_blank" href="/Reports/CallLogs?'
                    + "group=" + dataItem.Id
                    + "&domain=" + self.filterCdrByDomain()
                    + "&fromdate=" + DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate())
                    + "&todate=" + DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate())
                    + '"><i class="fa fa-user" aria-hidden="true"></i></a>';
                html += dataItem.Id;
                return html;
            };
            self.mainTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Reports/GetGroupsSummaryData",
                            type: "POST",
                            data: function () {
                                var data = {};
                                data.fromdate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByStartDate());
                                data.todate = DateUtils.toIsoStringDate(self.filterCdrSummaryReportByEndDate());
                                if (self.filterCdrByDomain()) {
                                    data.domain = self.filterCdrByDomain();
                                }
                                data.extension = self.selectedDomainGroups().join(",");
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    change: function (event) {
                        var data = event.sender.data();
                        console.log(data.length); // displays "77"
                    },
                    pageSize: 10000,
                    aggregate: gridStructure.aggregate,
                    serverPaging: false,
                    serverFiltering: true,
                    serverSorting: false,
                    serverAggregates: false,
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total",
                        aggregates: "Aggregates",
                        errors: "Errors"
                    },
                    sort: { field: "StartTime", dir: "desc" }
                },
                gridOptions: {
                    columns: columns,
                    autoBind: false,
                    height: "400px",
                    resizable: true,
                    scrollable: true,
                    pageable: false,
                    dataBound: function () {
                    }
                },
                enableExport: {
                    entityName: "QueuesSummaryReport",
                    title: "Groups Summary Report",
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: false
                },
                autoHeight: {
                    totalOffset: 222 + 90
                },
                enableStickyHeader: false,
                gridId: "tblQueuesSummary",
                showPagerOnTop: false,
                customLoading: true
            };
            self.mainTable.initGrid(gridOptions);
        };
        AgentGroupsSummaryReport.prototype.applyFilter = function () {
            _super.prototype.applyFilter.call(this);
            var self = this;
            self.mainTable.refresh();
        };
        AgentGroupsSummaryReport.prototype.clearFilter = function () {
            _super.prototype.clearFilter.call(this);
            var self = this;
            $("#domainsList").data("kendoDropDownList").value(self.domainList[0]);
            self.filterCdrByDomain(self.domainList[0]);
            self.filterCdrSummaryReportByStartDate(DateUtils.addDays(DateUtils.today(), -1));
            self.filterCdrSummaryReportByEndDate(DateUtils.addDays(DateUtils.today(), -1));
        };
        AgentGroupsSummaryReport.prototype.exportTo = function () {
            var self = this;
            if (self.canExport()) {
                self.mainTable.exportToMaterial();
            }
        };
        return AgentGroupsSummaryReport;
    }(ReportBase));
    setTimeout(function () {
        if (urls_1.urls.startsWith("/Reports/GroupsSummary")) {
            log.log("Initialize GroupsSummary list");
            $(function () {
                (new AgentGroupsSummaryReport()).init();
            });
        }
    }, 0);
    return AgentGroupsSummaryReport;
});
//# sourceMappingURL=agentGroupsSummaryReport.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/reports/agentGroupsSummaryReport.js
// module id = 255
// module chunks = 2